import React from "react";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import orderBy from "lodash/orderBy";
import {
  pathogenicColor,
  likelyPathogenicColor,
  uncertainSignificanceColor,
  benignColor,
} from "../../../../common/helpers/colors";

const tierNames = {
  I: "Tier I",
  II: "Tier II",
  III: "Tier III",
  IV: "Tier IV",
  NA: "N/A",
};

export const checkAMPClassification = (data) => {
  const tempArray = [];
  let tierLevel = "N/A";
  let color = "#373a3c";
  const obj = {};
  if (data) {
    data.forEach((item) => {
      tempArray.push(item.key);
    });
  }

  if (tempArray.includes("Tier I")) {
    tierLevel = "Tier I";
    color = pathogenicColor;
  } else if (tempArray.includes("Tier II")) {
    tierLevel = "Tier II";
    color = likelyPathogenicColor;
  } else if (tempArray.includes("Tier III")) {
    tierLevel = "Tier III";
    color = uncertainSignificanceColor;
  } else if (tempArray.includes("Tier IV")) {
    tierLevel = "Tier IV";
    color = benignColor;
  }
  obj.tierLevel = tierLevel;
  obj.color = color;
  return obj;
};

export const createChartData = (data, key) => {
  const tempArray = [];
  if (data) {
    data.forEach((record) => {
      const customProperty = record[key];
      if (tempArray.hasOwnProperty(customProperty)) {
        tempArray[customProperty] += 1;
      } else {
        tempArray[customProperty] = 1;
      }
    });
    const chartData = [];
    let value = "";
    let isAMP = false;
    if (key === "amp_tier") {
      isAMP = true;
    }
    for (const item in tempArray) {
      let obj = {};
      if (isAMP === true) {
        value = tierNames[item];
      } else {
        value = item;
      }
      obj = { key: value, value: tempArray[item] };
      chartData.push(obj);
    }
    return orderBy(chartData, (s) => s.value, ["desc"]);
  }
  return [];
};

export const getIconFromBool = (value) => {
  if (value === true)
    return <FontAwesomeIcon icon={faCheck} className="tw-text-green-600" />;
  if (value === false)
    return <FontAwesomeIcon icon={faTimes} className="tw-text-red-500" />;
  return "-";
};
